var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "590px",
    viewBox: "0 0 512 590",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "0%",
    cy: "50%",
    fx: "0%",
    fy: "50%",
    r: "100%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-39.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Polygon",
    fill: "url(#radialGradient-1)",
    points: "295 0 550.477494 147.5 550.477494 442.5 295 590 39.5225059 442.5 39.5225059 147.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.405895,231.673222 C249.86622,177.442259 339.785174,177.442259 395.245498,231.673222 L401.920237,238.200005 C404.693254,240.911553 404.693254,245.307841 401.920237,248.01939 L379.087286,270.346215 C377.700777,271.70199 375.452803,271.70199 374.066295,270.346215 L364.881061,261.364586 C326.190552,223.53171 263.460842,223.53171 224.770332,261.364586 L214.933705,270.98317 C213.547196,272.338943 211.299222,272.338943 209.912714,270.98317 L187.079763,248.656345 C184.306746,245.944796 184.306746,241.548508 187.079763,238.83696 L194.405895,231.673222 Z M442.604374,278.028982 L462.920749,297.842027 C465.69307,300.545655 465.693086,304.929097 462.920784,307.632745 L371.312843,396.972219 C368.540528,399.675881 364.045685,399.675911 361.273332,396.972289 C361.27332,396.972277 361.273308,396.972265 361.273296,396.972254 L296.255552,333.565428 C295.562469,332.889517 294.438759,332.889517 293.745675,333.565428 C293.74567,333.565432 293.745667,333.565436 293.745662,333.56544 L228.729303,396.972219 C225.956997,399.675888 221.462154,399.675932 218.689792,396.972318 C218.689775,396.972302 218.689758,396.972285 218.689741,396.972269 L127.079251,307.631607 C124.306916,304.927965 124.306916,300.544496 127.079251,297.840855 L147.395662,278.027844 C150.167997,275.324203 154.662839,275.324203 157.435173,278.027844 L222.453863,341.435555 C223.146947,342.111466 224.270657,342.111466 224.963741,341.435555 C224.963751,341.435546 224.96376,341.435536 224.96377,341.435528 L289.979202,278.027844 C292.751473,275.32414 297.246315,275.324039 300.018713,278.027618 C300.018752,278.027656 300.018791,278.027693 300.018829,278.027731 L365.037432,341.435528 C365.730516,342.111438 366.854226,342.111438 367.54731,341.435528 L432.564862,278.028982 C435.337197,275.32534 439.832039,275.32534 442.604374,278.028982 Z",
    id: "WalletConnect",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.00e3b589.svg";
export { ForwardRef as ReactComponent };